import { giphyLightGrey } from '@giphy/colors'
import { ReactNode, useContext } from 'react'
import UserContext from 'shared/contexts/user'
import { CopilotUploadPreset } from 'shared/types/copilot'
import { ControlSize } from 'types'
import { CreationToolUploadContext } from '../../manager'
import { CopilotContext } from '../context'
import { CopilotAlertContext } from '../contexts/alert'
import { CopilotDropdownContext } from '../contexts/dropdown'
import { hasUploadContextChanged } from '../utils/upload'
import PresetMenu from './menu'
import { Avatar, Button, LinkButton, Preset } from './style'

type Props = {
    children?: ReactNode
    className?: string
    preset: CopilotUploadPreset
    showEllipsisMenu?: boolean
    size: ControlSize
}

const CopilotPreset = ({ children, className, preset, size }: Props) => {
    const { user } = useContext(UserContext)
    const { activePresetId, hasChanges, activatePreset, copyPresetToClipboard } = useContext(CopilotContext)
    const { showAlert } = useContext(CopilotAlertContext)
    const { closeDropdown } = useContext(CopilotDropdownContext)
    const uploadContext = useContext(CreationToolUploadContext)
    const active = preset.id === activePresetId
    const avatarUrl = preset.upload_channel?.avatar_url || preset.author.avatar_url

    async function onClick() {
        closeDropdown()

        if (hasChanges || (!activePresetId && hasUploadContextChanged(uploadContext, user.username))) {
            await showAlert('overwrite')
        }

        activatePreset(preset.id)
    }

    return (
        <Preset $active={active} $size={size} className={className}>
            <Button
                color="transparent"
                icon={avatarUrl ? <Avatar src={avatarUrl} alt="" /> : undefined}
                iconLocation="left"
                size={size}
                textColor="inherit"
                title={preset.name}
                onClick={onClick}
            >
                {preset.name}
            </Button>
            {children}
            <LinkButton
                color={giphyLightGrey}
                icon="link"
                inverted
                size={size}
                onClick={() => copyPresetToClipboard(preset.id)}
            />
            <PresetMenu preset={preset} size={size} />
        </Preset>
    )
}

export default CopilotPreset
